import React from 'react';
import CheckUpTask from './CheckUpTask';

export default function PreventativeMaintenanceTask() {
  return <CheckUpTask variant="preventative" />;
}
